export const noWindHotelList = [
  150,
  1963,
  159,
  236,
  267,
  12017,
  390,
  247,
  307,
  356,
  362,
  37668,
  371,
  4184,
  4186,
  418,
  435,
  462,
  466,
  473,
  342
];

export const beautyReefHotelList = [
  195,
  253,
  134,
  57028,
  154,
  251,
  12107,
  218,
  15688,
  408,
  307,
  466,
  372,
  371,
  278,
  440,
  469,
  1962,
  12114,
  1963,
  513,
  338,
  13872,
  483,
  266,
  15693
];